<template lang="pug">
  .liaoning-flow
    .header
      img(src="../../../public/images/liaoning/darkgrownflowheader.png")
    .form
      el-form
        el-form-item
          el-input(type="text", v-model="form.mobile", placeholder="请输入辽宁移动手机号")
        el-form-item
          .verifycode
            .txt-verfiycode
              input(type="text", v-model="form.verifyCode", placeholder="请输入验证码", maxlength="6")
            .btn-verifycode
              button(type="button", :disabled="leftSendTime > 0", @click="sendVerifyCode")
                span(v-if="leftSendTime <= 0") 获取验证码
                span(v-else) {{leftSendTime}}秒后重试
        el-form-item.button-item
          img(src="../../../public/images/liaoning/darkgrownflowbutton.png", @click="handleSubmit")
    .notice-show-more(v-if="!showMoreNotice", @click="showMoreNotice = true")
      img(src="../../../public/images/liaoning/noticedown.png")
      p 点击查看详情
    .notice(v-else)
      .content
        img(src="../../../public/images/liaoning/darkgrownflownotice.png")
        ul
          li(v-for="(notice, index) in notices", :key="index")
            .num {{index + 1}}.
            p.content {{notice}}
</template>

<script>
export default {
  data() {
    return {
      leftSendTime: 0,
      notices: [
        '客户范围：限入网6个月及以上（含），且近6个月套餐、基础流量包、任我用流量包未降档的4G实名制客户办理。',
        '生效规则：活动办理立即生效，功能费一次收取，不区分上下半月。',
        '专属权益：享1年优+会员轻享版权益，办理成长包Plus版自动生效，到期自动取消。关注辽宁移动微信公众号，回复关键字“优+”，点击辽宁移动权益中心，领取10GB日流量、爱奇艺腾讯优酷芒果等视频会员优惠券、3折流量权益券、美团外卖8折代金券等。',
        '活动有效期内不可重复办理,新版成长包三档活动可叠加办理。',
        '已办理老版成长包系列活动客户，可以办理新版成长包系列活动。',
        '活动办理生效后，如客户有套餐、基础流量包、任我用流量降档需求，需先进行活动终止。',
        '办理活动后，客户如有申请办理预销户、携号转网业务，需终止活动。',
        '套外流量包内流量不支持结转及多终端共享。',
        '活动连带流量产品费用不计入翻倍送承诺低消范围内。'
      ],
      form: {
        mobile: '',
        verifyCode: '',
        carrierId: 10,
        userId: '',
        goodsCode: 'WXMP01600004'
      },
      channel: 'TUIA',
      showMoreNotice: false
    }
  },
  methods: {
    sendVerifyCode() {
      this.form.mobile = this.form.mobile.trim()
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      this.$service.CarrierService
        .sendVerifyCode({
          carrierId: this.form.carrierId,
          mobile: this.form.mobile,
          channel: this.channel,
          goodsCode: this.form.goodsCode
        })
        .then(res => {
          if (res.data.success) {
            this.leftSendTime = 60
            this.setSendTimeLeft()
            this.$message({
              type: 'success',
              message: '验证码已发送'
            })
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '系统错误，或请输入正确的手机号码'
          })
        })
    },
    setSendTimeLeft() {
      if (this.leftSendTime > 0) {
        this.leftSendTime -= 1
        setTimeout(() => {
          this.setSendTimeLeft()
        }, 1000)
      }
    },
    handleSubmit() {
      this.form.mobile = this.form.mobile.trim()
      this.form.verifyCode = this.form.verifyCode.trim()
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      if(this.form.verifyCode.length === 0) {
        this.$message({
          type: 'warning',
          message: '请填写短信验证码'
        })
        return;
      }
      if(this.form.verifyCode.length != 6) {
        this.$message({
          type: 'warning',
          message: '请填写6位验证码'
        })
        return;
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在处理中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.CarrierService
        .checkMobilePackage({
          carrierId: this.form.carrierId,
          mobile: this.form.mobile,
          goodsCode: this.form.goodsCode,
          verifyCode: this.form.verifyCode,
          channel: this.channel,
          userId: this.form.userId || 25995   // 缺省冀的用户ID
        })
        .then(res => {
          if (res.data.success) {
            this.addMobilePackage()
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '请求过程中发生错误，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    },
    addMobilePackage() {
      let _formData = {
        carrierId: this.form.carrierId,
        mobile: this.form.mobile,
        userId: this.form.userId || 25995,   // 缺省冀的用户ID,
        goodsCode: this.form.goodsCode,
        verifyCode: this.form.verifyCode,
        channel: this.channel
      }
      if (this.form.sharerId) {
        _formData.sharerId = this.form.sharerId
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在办理业务',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.CarrierService
        .addMobilePackage(_formData)
        .then(res => {
          if (res.data.success) {
            this.syncOrderStatus(res.data.sub_data.orderId)
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '办理失败，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    },
    syncOrderStatus(orderId) {
      try{
        let _loading = this.$loading({
          lock: true,
          text: '请稍后，正在查询办理结果',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        this.$service.CarrierService
          .queryOrder(orderId)
          .then(res => {
            // W-等待运营商返回处理结果；0-办理成功；1-办理失败，
            if (res.data.success) {
              if (res.data.sub_data.execStatus == '0') {
                _loading.close()
                if (window.countLog) {
                  window.countLog.ready(function() {
                    window.countLog.init(function() { 
                    }, {
                      isCopy: 0, 
                      pageType: 0 
                    })
                  })
                }
                this.$message({
                  type: 'success',
                  message: '办理成功'
                })
                this.$router.push({
                  name: 'liaoningFlowCommonSuccess'
                })
              } else if (res.data.sub_data.execStatus == 'W') {
                setTimeout(() => {
                  _loading.close()
                  this.syncOrderStatus(orderId)
                }, 1000)
              } else {
                _loading.close()
                this.$message({
                  type: 'warning',
                  message: `订单查询：办理失败`
                })
              }
            } else {
              _loading.close()
              this.$message({
                type: 'warning',
                message: res.data.message
              })
            }
          })
          .catch(() => {
            _loading.close()
            this.$message({
              type: 'error',
              message: '办理失败，请稍后再再试'
            })
          })
      } catch (err) {
        console.log(err)
        this.errlog = err.message;
      }
    }
  }
}
</script>

<style lang="less" scoped>
.liaoning-flow{
  background-color: #061645;
  padding-bottom: 2rem;
}
.header{
  img{
    width: 100%;
  }
}
.notice-show-more{
  color:#FFDCC6;
  text-align: center;
  width: 5rem;
  margin: 0 auto;
  font-size: .5rem;
  margin-top: 2rem;
  img{
    width: 40%;
  }
}
.notice{
  background: url('../../../public/images/liaoning/darkgrownflowbg.png') no-repeat;
  background-size: 100%;
  margin-top: 2rem;
  font: "黑体", "Arial";
  .title{
    text-align: center;
    color: #fff;
    margin-bottom: .5rem;
  }
  >.content{
    padding: .5rem .6rem;
    box-sizing: border-box;
    background: linear-gradient(180deg, rgba(81, 84, 143, 1), rgba(17, 27, 124, 1));
    box-shadow: 0px 0px 1px 1px #7479E2;
    border-radius: .25rem;
    width: 95%;
    margin: 0 auto;
    ul{
      li{
        clear: both;
        overflow: hidden;
        font-size: .8rem;
        color: #fff;
        margin-bottom: .2rem;
        .num{
          float: left;
          width: 1.4rem;
          line-height: 1.2rem;
        }
        .content{
          line-height: 1.2rem;
          margin-left: 1.3rem;

        }
      }
    }
    img{
      width: 100%;
    }
  }
}
.form{
  width: 84%;
  margin: 0 auto;
  margin-top: -200px;
  .button-item{
    text-align: center;
    img{
      width: 100%;
    }
  }
  .el-form-item{
    margin-bottom: 12px;
  }
  .verifycode{
    display: flex;
    height: 40px;
    line-height: 40px;
  }
  .btn-verifycode{
    flex: .7;
    button{
      background-color: #fff;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      width: 100%;
      border: 0;
      outline: 0;
      padding: 0;
      height: 40px;
      line-height: 40px;
      border-radius: 4px;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }
  .txt-verfiycode{
    width: 100%;
    flex: 1.3;
    input{
      background-color: #fff;
      // border: 1px solid #DCDFE6;
      border: 0;
      border-right: 0;
      padding: 0 15px;
      outline: 0;
      width: 100%;
      height: 40px;
      line-height: 40px;
      color: #606266;
      border-radius: 4px;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      border-right-color: #fff;
      box-sizing: border-box;
      &::-webkit-input-placeholder{
        color: #b9b9b9;
        font-size: 14px;
      }
    }
  }
}
</style>
